import { generateUUID } from './uuid.js';

/**
 * Resolve a stable sessionId for a widget config, shared by the embedded and
 * floating surfaces so both attribute to the same session (and so analytics
 * events always carry a non-empty sessionId). Restores from sessionStorage when
 * available — keyed by siteKey, or by clientId in demo mode — generating and
 * persisting a new UUID on first use. Falls back to a temporary UUID when
 * sessionStorage is unavailable (private mode, blocked storage, etc.).
 *
 * @param {object} config - widget config with siteKey (or clientId + mode 'demo')
 * @returns {string} sessionId
 */
export function getOrCreateSessionId(config) {
  const sessionKey = config.mode === 'demo'
    ? `chatbot-session-demo-${config.clientId}`
    : `chatbot-session-${config.siteKey}`;

  try {
    let sessionId = sessionStorage.getItem(sessionKey);

    if (!sessionId) {
      sessionId = generateUUID();
      sessionStorage.setItem(sessionKey, sessionId);
      console.log('ChatbotWidget: New session created:', sessionId);
    } else {
      console.log('ChatbotWidget: Existing session restored:', sessionId);
    }

    return sessionId;
  } catch (error) {
    console.warn('ChatbotWidget: Failed to access sessionStorage, using temporary session:', error);
    // Fallback to temporary sessionId if sessionStorage is not available
    return generateUUID();
  }
}
